import { createContext as o } from "react";
const e = o(void 0);
export {
  e as PropsContext
};
